export const nurseBaseAmount = [
    {
        base:78364
    }
]

export const nursePayIncrease = [
    {
        id: "0",
        expDiff: 0
    },
    {
        id: "1",
        expDiff: 904
    },
    {
        id: "2",
        expDiff: 1798
    },
    {
        id: "3",
        expDiff: 1798
    },
    {
        id: "4",
        expDiff: 2705
    },
    {
        id: "5",
        expDiff: 3605
    },
    {
        id: "6",
        expDiff: 3605
    },
    {
        id: "7",
        expDiff: 3905
    },
    {
        id: "10",
        expDiff: 4504
    },
    {
        id: "13",
        expDiff: 5112
    },
    {
        id: "15",
        expDiff: 5407
    },
    {
        id: "17",
        expDiff: 6356
    },
    {
        id: "18",
        expDiff: 6839
    },
    {
        id: "20",
        expDiff: 7307
    },
]

export const nurseLongevity = [
    {
        id: "None",
        amount: 0
    },
    {
        id: "5 but less than 7",
        amount: 1879
    },
    {
        id: "7 but less than 10",
        amount: 5865
    },
    {
        id: "10 but less than 15",
        amount: 7286
    },
    {
        id: "15 but less than 20",
        amount: 15108
    },
    {
        id: "20 but less than 22",
        amount: 19211
    },
    {
        id: "22 years or more",
        amount: 22113
    }
]

export const nurseEducation = [
    {
        id: "Base Salary",
        amount: 0
    },
    {
        id: "Baccalaureate Differential",
        amount: 1952
    },
    {
        id: "Masters Differential",
        amount: 3909
    }
]